// extracted by mini-css-extract-plugin
export default {"count":"SectionStats_count__U4thW"};